import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row, Layout } from 'antd'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import requests from '../services/requests'

const { Content } = Layout

class Dashboard extends Component {
  state = {
    loading: false,
    event: null,
    runners: [],
  }
  componentWillMount() {
    this.setState({
      loading: true,
      event: this.props.event,
    })
    this.getRunners()
    const intervalId = setInterval(() => this.getRunners(), 60000)
    this.setState({ intervalId })
  }
  componentWillUnmount() {
    clearInterval(this.state.intervalId)
  }
  async getRunners() {
    try {
      const runners = await requests.get(`/runners?eventId=${this.props.event.id}`)
      this.setState({ loading: false, runners })
    } catch (err) {
      console.error(err)
      this.setState({ loading: false })
    }
  }
  render() {
    return (
      <Layout>
        <Navbar event={this.state.event} selected="1" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            {!this.state.loading && (
              <Row gutter={8}>
                {this.state.runners.map(runner => (
                  <Col key={runner.id} span={8}>
                    <Card cover={<img src={runner.register.image} alt="" style={{ width: '100%' }} />} />
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Dashboard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    personGroupId: PropTypes.string,
  }),
}
Dashboard.defaultProps = {
  event: {},
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js